import React from 'react';
import styled from 'styled-components';
import { Step } from '.';

interface StepperContentProps {
    className: string,
    step: Step,
};

const StepperContent = ({ className, step: { customHeader, stepContent } }: StepperContentProps) => {
    return (
        <StyledStepperContent
            className={className}
        >
            {stepContent}
        </StyledStepperContent>
    );
}

export default StepperContent;

const StyledStepperContent: any = styled.div`
    // The purpose of this calculation is to make the footer fixed to the bottom of the screen.
    // We are assuming that the stepper will always be contained within a drawer, so 200px is
    // hard-coded here to accommodate the height of the drawer header, footer, and other
    // components of the drawer. 
    // TODO: figure out other ways to accomplish a fixed footer so that we don't need to hard code this value.
    max-height: calc(100vh - 200px);
    min-height: calc(100vh - 200px);
    // additional padding added on mobile devices where the top and bottom may be obscured by url and menu
    @media only screen (pointer: course) and (max-width: 798px) {
        max-height: calc(100vh - 325px);
        min-height: calc(100vh - 325px);
    }
    overflow-y: auto;
`;